var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.classes,attrs:{"aria-hidden":_vm.ariaHidden},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }